import { Box, Heading, Text, Button, VStack, HStack, Link, IconButton, useColorMode } from '@chakra-ui/react'
import { FiSun, FiMoon } from 'react-icons/fi'
import { CategoryTotal } from './CategoryTotalAI.jsx'
import { LoadingCtx } from './LoadingCtxAI.jsx'

const DarkModeToggle = () => {
  const {colorMode, toggleColorMode} = useColorMode()
  return <IconButton icon={colorMode === 'light' ? <FiMoon /> : <FiSun />} onClick={toggleColorMode} variant="ghost" aria-label="Toggle dark mode" />
}

export const donaLinks = {
  media: '/media',
  submitMedia: '/submit-media',
  donors: '/donors',
}

const mainNavButtons = [
  {href: '/', label: 'Strings'},
  {href: donaLinks.media, label: 'Media'},
  {href: '/charities', label: 'Charities'},
  {href: donaLinks.donors, label: 'Donors'},
]

const isMediaSection = (path) => path === donaLinks.media || path === donaLinks.submitMedia
const isDonorsSection = (path) => path === donaLinks.donors || path?.startsWith('/profile/')

export const LeaderboardLayout = (/** @type {{title?: any, subtitle?: any, categoryKind?: any, currentPath?: any, loading?: any, children?: any}} */ {title, subtitle, categoryKind, currentPath, loading, children}) => {
  return (
    <LoadingCtx.Provider value={{loading}}>
      <Box maxW="1200px" mx="auto" p={8} position="relative">
        <Box position="absolute" top={2} right={2}><DarkModeToggle /></Box>
        <VStack spacing={6} align="stretch">
          <Heading size="xl" textAlign="center">{title}</Heading>
          <Text textAlign="center" fontSize="lg">{subtitle}</Text>

          <CategoryTotal kind={categoryKind} />

          <HStack justify="center" spacing={4} wrap="wrap">
            {mainNavButtons.map(b => {
              const isActive = b.href === currentPath || (b.href === donaLinks.media && isMediaSection(currentPath)) || (b.href === donaLinks.donors && isDonorsSection(currentPath))
              return (
                <Link key={b.href} href={b.href}>
                  <Button variant={isActive ? 'solid' : 'outline'} colorScheme={isActive ? 'blue' : 'gray'}>{b.label}</Button>
                </Link>
              )
            })}
          </HStack>

          {children}
        </VStack>
      </Box>
    </LoadingCtx.Provider>
  )
}
